import { Grid } from "@material-ui/core";
import CountersFilter from "./CountersFilter";
import CountersTabs from "./CountersTabs";
import CountersTable from "./CountersTable";
import CounterPagination from "./CounterPgagination";

const ProjectCounters = ({
  projectId,
  devices,
  sort,
  reverse,
  counterTab,
  changeCounterTab,
  gasPage,
  powerPage,
  waterPage,
  updateTable,
  changePage,
  consumptions,
  tableLoading,
  dataCount,
  projectTab,
}) => {
  const styles = {
    container: { padding: "5px 15px", margin: "10px auto" },
    pagination: {
      padding: "5px 15px",
      marginBottom: "10px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
    },
    counterFilters: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "5px 15px",
      margin: "5px 15px",
      border: "1px solid #ccc",
      borderRadius: "5px",
    },
  };
  const savePageStates = () => {
    let projectStates = {
      id: projectId,
      projectTab: projectTab,
      counterTab: counterTab.value,
      filters: {
        reverseValue: reverse.value,
        sortValue: sort.value,
        count: dataCount.value,
      },
      pages: {
        gas: gasPage.value,
        power: powerPage.value,
        water: waterPage.value,
      },
      data: consumptions,
    };
    window.localStorage.setItem("dashHistory", JSON.stringify(projectStates));
  };
  return (
    <>
      <Grid item xs={12} sm={12} md={12} lg={12} style={styles.counterFilters}>
        <CountersFilter
          sort={sort}
          reverse={reverse}
          update={updateTable}
          count={dataCount}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} style={styles.container}>
        <CountersTabs counterTab={counterTab} changeTab={changeCounterTab} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} style={styles.container}>
        <CountersTable
          projectId={projectId}
          counterTab={counterTab}
          devices={devices}
          waterPage={waterPage}
          gasPage={gasPage}
          powerPage={powerPage}
          loading={tableLoading}
          consumptions={consumptions}
          count={dataCount}
          savePageStates={savePageStates}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} style={styles.pagination}>
        <CounterPagination
          devices={devices}
          counterTab={counterTab}
          waterPage={waterPage}
          gasPage={gasPage}
          powerPage={powerPage}
          changePage={changePage}
          count={dataCount}
        />
      </Grid>
    </>
  );
};
export default ProjectCounters;
